import {
  Card,
  Col,
  Progress,
  Radio,
  Row,
  Select,
  Skeleton,
  Tabs,
  Typography,
  Descriptions,
  Table,
  Tag,
  Badge,
  Tooltip,
  Dropdown,
  Menu,
  Button,
} from "antd";
import { DownOutlined } from "@ant-design/icons";
import React, { useContext, useEffect, useState } from "react";
import apiPath from "../../constants/apiPath";
import { AppStateContext } from "../../context/AppContext";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import { useNavigate } from "react-router";
import { useAuthContext } from "../../context/AuthContext";
import { Link } from "react-router-dom";
import moment from "moment";
import ImportForm from "../../components/ImportForm";
import DurationChallengePieChart, {
  CategoryChallengePieChart,
  EmotionChallengePieChart,
} from "../../components/Chart/ChallengePieChart";
const { Title, Text } = Typography;

const years = [2024, 2025];

function Home() {
  const { setPageHeading, country } = useContext(AppStateContext);

  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [year, setYear] = useState(years[0]);
  const { userProfile } = useAuthContext();
  const [dashboard, setDashboard] = useState();
  const [listing, setListing] = useState([]);
  const [queryListing, setQueryListing] = useState([]);
  const [pieChart, setPieChart] = useState();

  const count = [
    // {
    //   today: "Inactive Customers",
    //   title: `${dashboard?.totalCustomer || 0}`,

    //   icon: <i class="fas fa-user-friends"></i>,
    //   bnb: "bnb2",
    //   url: "/customer",
    //   key: "customer-management",
    // },
    {
      today: "Active Customers",
      title: `${dashboard?.totalCustomer || 0}`,

      icon: <i class="fas fa-user-friends"></i>,
      bnb: "bnb2",
      url: "/customer",
      key: "customer-management",
    },
    {
      today: "Number of Challenges",
      title: `${dashboard?.challenges || 0}`,
      icon: <i className="fas fa-people-carry"></i>,
      bnb: "bnb2",
      url: "/challenge?tab=creative",
      key: "challenge-management",
    },
    {
      today: "Number of Rewards Redeemed",
      title: `${dashboard?.totalOrders || 0}`,
      icon: <i className="fas fa-people-carry"></i>,
      bnb: "bnb2",
      // url: "/order",
      key: "order-management",
    },
    {
      today: "Number of Products",
      title: `${dashboard?.productCount || 0}`,
      icon: <i className="fas fa-people-carry"></i>,
      bnb: "bnb2",
      url: "/product",
      key: "product-management",
    },
    {
      today: "Number of checked-In Emotion Count",
      title: `${dashboard?.checkedInEmotionCount || 0}`,
      icon: <i className="fas fa-people-carry"></i>,
      bnb: "bnb2",
      // url: "/order",
      key: "checked-management",
    },
  ];

  const orders = [
    {
      title: "Order id",
      dataIndex: "index",
      key: "index",
      render: (_, { order_id }) =>
        order_id ? <span className="cap">#{order_id}</span> : "-",
    },
    {
      title: "Customer Name",
      dataIndex: "name",
      key: "name",
      render: (_, { user_id }) =>
        user_id ? (
          <div style={{ display: "flex", gap: 2, flexDirection: "column" }}>
            {user_id?.name && <span className="cap">{user_id.name}</span>}
            {user_id?.country_code && user_id?.mobile_number && (
              <span className="cap" style={{ fontSize: "14px", color: "gray" }}>
                (
                {user_id.country_code?.includes("+")
                  ? user_id.country_code
                  : "+" + user_id.country_code}
                ) {user_id.mobile_number}
              </span>
            )}
            {user_id?.email && (
              <span style={{ fontSize: "14px", color: "gray" }}>
                {user_id.email}
              </span>
            )}
          </div>
        ) : (
          "-"
        ),
      sorter: (a, b) => {
        let nameA = a.user_id?.name;
        let nameB = b.user_id?.name;
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      },
    },
    {
      title: "Total Amount",
      dataIndex: "amount",
      key: "amount",
      render: (_, { amount }) => (
        <span className="cap">{amount?.toFixed(2) ?? 0.0}</span>
      ),
      sorter: (a, b) => {
        let nameA = a.amount;
        let nameB = b.amount;
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      },
    },
    {
      title: "Order Date",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return (
          <span>
            {moment(created_at).format("ll")},{" "}
            {moment(created_at).format("HH:mm a")}
          </span>
        );
      },
      sorter: (a, b) => a.created_at?.localeCompare(b?.created_at),
    },
  ];

  const queries = [
    {
      title: "Name",
      dataIndex: "user_id",
      key: "user_id",
      width: 200,
      sorter: (a, b) => a.user_id?.name?.localeCompare(b.user_id?.name),
      render: (_, { user_id }) => {
        return user_id ? user_id?.name : "-";
      },
    },

    {
      title: "Email ID",
      dataIndex: "email",
      key: "email",
      // sorter: (a, b) => a.email?.localeCompare(b.email),
      render: (_, { user_id }) => {
        return user_id ? (
          <span style={{ textTransform: "lowercase" }}>{user_id?.email}</span>
        ) : (
          "-"
        );
      },
    },
    {
      title: "Query Message",
      dataIndex: "message",
      key: "message",
      width: 200,
      render: (_, { message }) => {
        return message ? message : "-";
      },
    },
    {
      title: "Query On",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return moment(created_at).format("ll");
      },
    },
  ];

  const fetchData = () => {
    request({
      url: apiPath.getChallengePieChart,
      method: "GET",
      onSuccess: ({ data }) => {
        setLoading(false);
        setPieChart(data?.data);
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
      },
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    setPageHeading("Welcome Admin");
    if (!userProfile) return;

    setLoading(true);
    request({
      url: apiPath.dashboard + `${year ? `?year=${year}` : ""}`,
      method: "GET",
      onSuccess: ({ data }) => {
        setLoading(false);
        setListing(data?.orders);
        setQueryListing(data?.queries);
        setDashboard(data?.data);
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  }, [userProfile, refresh]);

  return (
    <>
      <div className="page-top-space home-card layout-content">
        <div className="mb-24">
          <div className="sub_title">
            <p>Here is the information about all your business</p>
          </div>
          <Row gutter={[24, 0]}>
            <Col xs={24} sm={24} md={24}>
              <Row
                className="rowgap-vbox"
                gutter={[24, 16]}
                // style={{ marginLeft: "0" }}
              >
                {count.map((c, index) => {
                  return (
                    <Col
                      key={index}
                      xs={24}
                      sm={24}
                      md={12}
                      lg={12}
                      xl={8}
                      xxl={6}
                      className="mb24"
                      style={{ paddingRight: "0px" }}
                    >
                      <Link to={userProfile?.type == "Sub Admin" ? '#' : c.url}>
                        <Card
                          bordered={false}
                          className="criclebox"
                          style={{ height: "100%" }}
                        >
                          <div className="number">
                            <Row align="middle" gutter={[24, 0]}>
                              <Col xs={18}>
                                <span>{c.today}</span>
                                <Title level={3}>{c.title}</Title>
                              </Col>
                              <Col xs={6}>
                                {" "}
                                <div className="icon-box">{c.icon}</div>
                              </Col>
                            </Row>
                          </div>
                        </Card>
                      </Link>
                    </Col>
                  );
                })}
              </Row>
            </Col>
          </Row>
        </div>

        <Row className="mt-3" gutter={[24, 0]}>
          <Col span={24}>
            <Card bordered={false} className="criclebox tablespace mb-24">
              <p className="dashboard-table-heading">Recent Queries (10) </p>
              <div className="table-responsive">
                <Table
                  loading={loading}
                  columns={queries}
                  dataSource={queryListing}
                  pagination={false}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>

        <Row className="mt-3" gutter={[24, 0]}>
          <Col span={24}>
            <Card bordered={false} className="criclebox tablespace mb-24">
              <p className="dashboard-table-heading">Recent Orders (10) </p>
              <div className="table-responsive">
                <Table
                  loading={loading}
                  columns={orders}
                  dataSource={listing}
                  pagination={false}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>

        <Row className="mt-3" gutter={[24, 0]}>
          <Col xs={24} xl={24}>
            <Card bordered={false} className="criclebox tablespace mb-24">
              <Row gutter={[24, 32]}>
                <Col span={24} lg={12} xxl={8}>
                  <p className="dashboard-table-heading text-center">Challenge Duration</p>
                  <DurationChallengePieChart data={pieChart} />
                </Col>
                <Col span={24} lg={12} xxl={8}>
                  <p className="dashboard-table-heading text-center">Challenge Categories</p>
                  <CategoryChallengePieChart data={pieChart} />
                </Col>
                <Col span={24} lg={12} xxl={8}>
                  <p className="dashboard-table-heading text-center">Emotion CheckIns</p>
                  <EmotionChallengePieChart data={pieChart} />
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Home;
